import { Paper, MuiThemeProvider } from '@material-ui/core';
import AddIcon from '@material-ui/icons/AddBox';
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as actions from 'components/TrustCenter/store/actions';
import AddShipper from './AddShipper/AddShipper';
import TMSAgreements from './TMSAgreements/TMSAgreements';
import cs from 'classnames';
import css from './TMS.module.css';
import { IconButton, Button } from '@material-ui/core';
import { isNotEmptyList, isBlank, isNotBlank } from 'components/Common/Utils/StringUtils';
import { isOtherGroupInEditMode } from './Utils/TMSUtils';
import baseCSS from 'components/TrustCenter/TrustCenter.module.css';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import TDialog from 'components/UI/Dialog/TDialog';
import {
    PRIMARY_BUTTON_DEFAULT_NEGATIVE_THEME,
    PRIMARY_BUTTON_DEFAULT_POSITIVE_THEME
} from 'components/UI/Button/ButtonMuiTheme';
import { validateWriteAccess } from 'components/Common/ResourceAccessValidation/ResourceAccessValidation';
import * as Constants from 'constants/Constants';
import Auxiliary from 'hoc/Auxiliary';
import EventTypesDropDown from 'components/TrustCenter/Common/EventTypesDropDown/EventTypesDropDown';
import get from 'lodash/get';

const TMS = (props) => {
    const {
        agreements,
        agreementList,
        newAgreementGroup,
        groupName,
        existingAgreementGroup,
        updateExistingAgreementGroup,
        isAgreementInEditMode,
        editedAgreements,
        newShipperAgreement,
        newTruckAgreements,
        sidebarResource,
        disableOtherOperation,
        hideLocalElement,
        trustCenterEvents,
        discardChanges,
        currentAccountType
    } = props;

    const [showAddShipperModel, setShowAddShipperModel] = useState(false);

    const [showDeleteAll, setShowDeleteAll] = useState(false);

    const [executeDelete, setExecuteDelete] = useState(false);

    const [openConfimation, setOpenConfimation] = useState(false);

    const [isWriteAccessGranted, setWriteAccessGranted] = useState(false);

    const [selectedEvents, setSelectedEvents] = useState([]);

    const [resetEventError, setResetEventError] = useState(false);

    useEffect(() => {
        setWriteAccessGranted(
            validateWriteAccess(
                sidebarResource,
                Constants.TRUSTCENTER_RESOURCE,
                Constants.TRUSTCENTER_FEATURE
            )
        );
    }, [sidebarResource]);

    useEffect(() => {
        if (isNotBlank(groupName) && Object.keys(agreements).length > 0) {
            setSelectedEvents(transformEventObjectToType());
        }
    }, [agreements, groupName, trustCenterEvents]);

    useEffect(() => {
        if (discardChanges) {
            if (existingAgreementGroup.hasOwnProperty(groupName)) {
                setSelectedEvents(transformEventObjectToType());
            }
            updateExistingAgreementGroup({});
            setResetEventError(true);
        }
    }, [discardChanges]);

    useEffect(() => {
        if (existingAgreementGroup.hasOwnProperty(groupName)) {
            if (isNotEmptyList(existingAgreementGroup[groupName].event_types)) {
                setSelectedEvents([...existingAgreementGroup[groupName].event_types]);
            }
        }
    }, [existingAgreementGroup]);

    const toggleAddShipperModal = () => {
        setShowAddShipperModel(true);
    };

    const closeAddShipperModel = () => {
        setShowAddShipperModel(false);
    };

    const transformEventObjectToType = () => {
        let eventArray = [];
        let editedEventTypes = [];
        const eventTypes = get(agreements, `["${groupName}"][0].event_types`, []);

        if (isNotEmptyList(eventTypes)) {
            editedEventTypes = [...eventTypes];
        }

        if (isNotEmptyList(editedEventTypes)) {
            editedEventTypes?.filter((row) => {
                const filterEvent = trustCenterEvents?.find((eve) => eve?.name === row?.name);
                if (filterEvent !== undefined) {
                    eventArray?.push(filterEvent?.message_type);
                }
                return true;
            });
        }
        if (trustCenterEvents?.length > 0 && eventArray?.length === trustCenterEvents?.length) {
            eventArray?.push(Constants.TRUSTCENTER_ALL_EVENTS);
        }
        return eventArray;
    };

    const deleteSelectedShippers = () => {
        setExecuteDelete(true);
        openConfirmationDialog(false);
        setShowDeleteAll(false);
    };

    const openConfirmationDialog = (closeDialog) => {
        setOpenConfimation(closeDialog);
    };

    const disableButton = () => {
        return isNotEmptyList(Object.keys(isAgreementInEditMode)) || disablDeleteAllButtons();
    };

    const disablDeleteAllButtons = () => {
        return (
            isBlank(groupName) ||
            !isWriteAccessGranted ||
            disableOtherOperation ||
            isOtherGroupInEditMode(
                newAgreementGroup,
                existingAgreementGroup,
                editedAgreements,
                newShipperAgreement,
                groupName,
                isAgreementInEditMode,
                newTruckAgreements
            )
        );
    };

    const dialogAction = (
        <div>
            <MuiThemeProvider theme={PRIMARY_BUTTON_DEFAULT_NEGATIVE_THEME}>
                <Button component="span" onClick={() => openConfirmationDialog(false)}>
                    No
                </Button>
            </MuiThemeProvider>
            <MuiThemeProvider theme={PRIMARY_BUTTON_DEFAULT_POSITIVE_THEME}>
                <Button component="span" onClick={() => deleteSelectedShippers()}>
                    Yes
                </Button>
            </MuiThemeProvider>
        </div>
    );

    return (
        <div className="full-width">
            {currentAccountType === Constants.AGREEMENT_TYPE_VISIBILITY ? (
                <div className="row">
                    <div className="col-sm-12">
                        <EventTypesDropDown
                            groupName={groupName}
                            selectedEvents={selectedEvents}
                            setSelectedEvents={setSelectedEvents}
                            trustCenterEvents={trustCenterEvents}
                            resetEventError={resetEventError}
                            setResetEventError={setResetEventError}
                        />
                    </div>
                </div>
            ) : null}
            <div className={css.TMSTable}>
                <Paper elevation={1}>
                    <div>
                        <div className={cs('row full-width no-gutters', css.headerSpacing)}>
                            <div className={cs('col-sm-5', 'align-self-center', css.TMSheader)}>
                                Shippers
                            </div>
                            <div className="col-sm-7 text-right">
                                {!hideLocalElement && (
                                    <Auxiliary>
                                        <IconButton
                                            id={'add-shipper'}
                                            classes={{ disabled: baseCSS.disabledIconButton }}
                                            disabled={disableButton()}
                                            onClick={() => toggleAddShipperModal()}
                                        >
                                            <AddIcon className="icon-button" />
                                        </IconButton>
                                        {showDeleteAll ? (
                                            <IconButton
                                                disabled={disableButton()}
                                                classes={{ disabled: baseCSS.disabledIconButton }}
                                                onClick={() => openConfirmationDialog(true)}
                                                id={'deleteAll'}
                                            >
                                                <DeleteForeverIcon className="icon-button" />
                                            </IconButton>
                                        ) : null}
                                    </Auxiliary>
                                )}
                            </div>
                        </div>
                        <div>
                            <TMSAgreements
                                hideLocalElement={hideLocalElement}
                                setShowDeleteAll={setShowDeleteAll}
                                groupName={groupName}
                                executeDelete={executeDelete}
                                setExecuteDelete={setExecuteDelete}
                                agreementList={isNotEmptyList(agreementList) ? agreementList : []}
                                discardChanges={discardChanges}
                            />
                        </div>
                    </div>
                </Paper>
            </div>
            <AddShipper
                groupName={groupName}
                showAddShipperModel={showAddShipperModel}
                closeAddShipperModel={closeAddShipperModel}
            />
            <TDialog
                id={'cancel_request'}
                open={openConfimation}
                handleClose={() => openConfirmationDialog(false)}
                dialogContentText={'Are you sure you want to delete these shipper code(s)?'}
                dialogTitle={'Confirmation'}
                dialogActions={dialogAction}
            />
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        newAgreementGroup: state.agreement.newAgreementGroup,
        agreements: state.agreement.agreements,
        existingAgreementGroup: state.agreement.existingAgreementGroup,
        isAgreementInEditMode: state.agreement.isAgreementInEditMode,
        newShipperAgreement: state.agreement.newShipperAgreement,
        editedAgreements: state.agreement.editedAgreements,
        newTruckAgreements: state.agreement.newTruckAgreements,
        disableOtherOperation: state.agreement.disableOtherOperation,
        trustCenterEvents: state.agreement.trustCenterEvents,
        sidebarResource: state.header.sidebarResource,
        discardChanges: state.agreement.discardChanges,
        currentAccountType: state.connection.currentAccountType
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateNewAgreementGroup: (agreementGroupData) =>
            dispatch(actions.updateNewAgreementGroup(agreementGroupData)),
        updateExistingAgreementGroup: (editedExistingAgreementGroup) => {
            dispatch(actions.updateExistingAgreementGroup(editedExistingAgreementGroup));
        },
        resetDiscardFlag: () => dispatch(actions.discardChanges(false))
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TMS));
